import { FC, memo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Form } from 'features/Form';
import { FormalizedZipRequestDto } from 'shared/api';
import { FORMALIZED_ZIP_FORM_FIELDS } from '../../constants/formalizedZipConstants';

interface FormalizedZipFormProps {
  isOpen: boolean;
  editingItem: FormalizedZipRequestDto | null;
  isEditing: boolean;
  onSubmit: (data: FormalizedZipRequestDto) => void;
  onCancel: () => void;
  loading?: boolean;
}

export const FormalizedZipForm: FC<FormalizedZipFormProps> = memo(({
  isOpen,
  editingItem,
  isEditing,
  onSubmit,
  onCancel,
  loading,
}) => (
  <Modal
    title={isEditing ? 'Редактировать формализованный ЗИП' : 'Создать формализованный ЗИП'}
    open={isOpen}
    onCancel={onCancel}
    footer={null}
    destroyOnClose
    width={600}
  >
    {loading && isEditing ? (
      <div style={{ padding: 24 }}>Загрузка данных...</div>
    ) : (
      <Form
        fields={FORMALIZED_ZIP_FORM_FIELDS}
        initialValues={editingItem || {}}
        onSubmit={onSubmit}
      />
    )}
  </Modal>
));

FormalizedZipForm.displayName = 'FormalizedZipForm';
